export const common = {
  // Navigation
  home: "Inicio",
  features: "Ventajas principales",
  cases: "Casos de estudio",
  pricing: "Precios del servicio",
  about: "Acerca de nosotros",
  getStarted: "Comenzar",
  language: "Español",
  
  // Hero Section
  heroSubtitle: "Flidge, especialistas en localización de videojuegos de la más alta calidad",
  heroTitle1: "Permite que jugadores de todo el mundo",
  heroTitle2: "conecten de verdad con tu juego",
  heroDescription: "Con tecnología de IA avanzada, ofrecemos a los desarrolladores soluciones de traducción multilingüe precisas, rápidas y rentables, ayudándote a expandirte al mercado global de jugadores y explorar nuevas oportunidades",
  learnMore: "Descubre las ventajas",
  freeTrial: "Prueba gratuita",
  socialProof: "La elección de más de 80 desarrolladores y distribuidores de videojuegos",
  
  // CTA Section
  ctaTitle1: "Haz que el mundo",
  ctaTitle2: "se enamore de tu juego",
  
  // Features Section
  featuresSubtitle: "Ventajas principales",
  featuresTitle: "Solución eficiente para la localización de juegos",
  
  feature1Title: "Eficiencia y rapidez",
  feature1Description: "Traducciones precisas y de alta calidad en plazos más cortos: capacidad de traducir 200,000 caracteres en 1 día. Mejora significativamente la eficiencia de localización de proyectos de videojuegos. En comparación con la traducción humana tradicional, reduce notablemente los errores humanos, identifica con precisión las diferencias de puntuación y mayúsculas/minúsculas, con calidad certificada por agencias de traducción profesionales.",
  
  feature2Title: "Multilingüe y multiescenarío",
  feature2Description: "Ofrecemos servicios de traducción en 64 idiomas globalmente, cubriendo guiones de juego, páginas de tienda, nombres de juegos, glosarios, sitios web oficiales y más. Cubrimos integralmente todas tus necesidades de localización.",
  
  feature3Title: "Admite múltiples formatos de texto",
  feature3Description: "Admite múltiples formatos de texto para importación y exportación, lo que te permite integrar fácilmente las traducciones en tu proyecto de juego. Independientemente del motor de juegos que utilices, podrás integrarlo de manera eficiente.",
  
  feature4Title: "Servicios de localización especializados en videojuegos",
  feature4Description: "Especializado en localización de videojuegos, con profundo conocimiento de textos, diálogos e interfaces. Nuestra amplia biblioteca de terminología garantiza expresiones naturales y localizadas para que los jugadores conecten mejor con tu juego.",

  // Game localization specific terms for features section
  glossary: "Glosario",
  gameTermsReference: "Glosario de términos del juego",
  completed: "Completado",
  storePage: "Página de la tienda",
  storePageDesc: "Nombre del juego, descripción, características principales, eslóganes promocionales",
  inProgress: "En proceso",
  gameStoryTranslation: "Traducción de guion del juego",
  gameStoryDesc: "Historia principal y misiones secundarias",
  pending: "Pendiente",
  
  // Additional feature terms
  translationTimeComparison: "Comparación de tiempo de traducción",
  basedOnProject: "Basado en proyecto de 200,000 caracteres",
  traditionalAgency: "Agencias tradicionales",
  aiPlatform: "Flidge AI - Servicio de traducción",
  "10days": "10 días",
  "1day": "1 día",
  "240hours": "240 horas",
  "24hours": "24 horas",
  professionalGlossary: "Glosario Profesional",
  more: "Más",
  flidgeLogo: "Logo de Flidge",

  // New entries inserted
  professionalTerminologyDatabase: 'Glosario especializado',
  cheese: 'Cheese',
  feeding: 'Feeding',
  rush: 'Rush',
  balance: 'Balance',
  fightingGamesJapanese: 'Juegos de lucha - Japonés',
  mobaGamesKorean: 'Juegos MOBA - Coreano',
  starcraftRussian: 'StarCraft - Russian',
  actionGamesChinese: 'Juegos de acción - Chino',

  // Statistics Section
  stat1Number: "80+",
  stat1Label: "Empresas atendidas",
  stat2Number: "64",
  stat2Label: "Idiomas disponibles",
  stat3Number: "97%",
  stat3Label: "Satisfacción del cliente",
  stat4Number: "24 horas",
  stat4Label: "Tiempo de respuesta",

  // Game types and case studies
  platformActionGame: "Juego de plataformas y acción",
  musicRhythmGame: "Juego de ritmo",
  actionStealthGame: "Juego de acción y sigilo",
  casualPuzzleGame: "Juego casual de rompecabezas",
  roguelikeCardGame: "Juego de gestión de simulación",
  simulationGame: "Juego de simulación y gestión",
  
  // Case study descriptions
  haakCaseDescription: "Proporcionamos soporte de traducción en 14 idiomas para el juego estilo metroidvania HAAK, aumentando las ventas mensuales en un 147%",
  museDashCaseDescription: "Proporcionamos servicios de traducción en japonés, coreano e inglés para el juego musical Muse Dash, proporcionando contenido localizado de alta calidad a más de 100 millones de jugadores en todo el mundo",
  kristalaCaseDescription: "Proporcionamos traducción al chino para el juego de acción y sigilo Kristala, incluyendo la traducción del nombre del juego y su página en la tienda",
  lazyMeowCityCaseDescription: "Brindamos soporte de localización en inglés, japonés y coreano para el juego casual de rompecabezas Lazy Meow City, contribuyendo a su expansión en el mercado de Asia-Pacífico",
  stoneSquadCaseDescription: "Ofrecemos soporte en 30 idiomas para StoneSquad, incluyendo inglés, japonés, coreano, portugués, español, entre otros",
  catHotelCaseDescription: "Proporcionamos servicios de traducción de historia, misiones, objetos y página de tienda en inglés, japonés, chino simplificado y chino tradicional para CatHotel, asegurando una experiencia de juego más localizada",
  
  // Additional case study terms
  haakDescription: "Proporcionamos soporte de traducción en 14 idiomas para el juego estilo metroidvania HAAK, aumentando las ventas mensuales en un 147%",
  museDashDescription: "Proporcionamos servicios de traducción en japonés, coreano e inglés para el juego musical Muse Dash, proporcionando contenido localizado de alta calidad a más de 100 millones de jugadores en todo el mundo",
  kristalaDescription: "Proporcionamos traducción al chino para el juego de acción y sigilo Kristala, incluyendo la traducción del nombre del juego y su página en la tienda",
  lazyMeowDescription: "Brindamos soporte de localización en inglés, japonés y coreano para el juego casual de rompecabezas Lazy Meow City, contribuyendo a su expansión en el mercado de Asia-Pacífico",
  stoneSquadDescription: "Ofrecemos soporte en 12 idiomas para Cooking Go, incluyendo inglés, japonés, coreano, francés, español, entre otros",
  catHotelDescription: "Proporcionamos servicios de traducción de historia, misiones, objetos y página de tienda en inglés, japonés, chino simplificado y chino tradicional para CatHotel, asegurando una experiencia de juego más localizada",
  
  // Results
  result: "Resultado",
  monthlyRevenueGrowth: "147% de crecimiento en ingresos mensuales",
  playerReviews: "Reseñas positivas de jugadores",
  translationCompleted: "Traducción completada",
  salesIncrease: "Aumento en ventas",
  exposureGrowth: "Crecimiento en exposición",
  playerReviews2: "Reseñas positivas de jugadores",
  
  // Cases Section
  casesSubtitle: "Casos de Estudio",
  casesTitle: "Ayudando a los juegos indie a llegar a jugadores en todo el mundo",
  casesDescription: "Valoramos cada oportunidad de cooperación, y ayudar a más juegos indie a ser vistos por más jugadores globalmente es nuestra misión",
  
  // Pricing Section
  pricingSubtitle: "Precios del servicio",
  pricingTitle: "Planes de precios transparentes",
  pricingDescription: "Ofrecemos planes de precios flexibles para proyectos de cualquier escala. Cada cliente puede disfrutar de un periodo de prueba gratuito.",
  
  freeTrialTitle: "Créditos de prueba gratis",
  standardPricing: "Precio estándar",
  standardPricingDescription: "Tarifa estándar tras exceder la cuota gratuita",
  enterpriseCustom: "Personalizado Empresarial",
  recommended: "Recomendado",
  perCharacter: "Por carácter",
  perLanguage: "Por idioma",
  customPrice: "Personalizado",
  customPlan: "Planes de Precios",
  customPlanDescription: "Precios especiales para proyectos grandes",
  startUsing: "Comenzar",
  contactBusinessTeam: "Hablar con Ventas",
  
  // Pricing Section Additional
  languagesCount: "Idiomas",
  freeExperience: "Prueba Gratuita",
  freeTrialDescription: "Cada colaborador puede obtener una prueba gratuita de 5000 caracteres traducidos a un solo idioma para conocer nuestra calidad de traducción",
  
  standardPricingFeatures: {
    languages: "Soporte para traducción en 64 idiomas",
    speed: "Traducción de 200,000 caracteres en 24 horas",
    formats: "Compatibilidad con múltiples formatos de archivo",
    glossary: "Glosario especializado de gaming",
    quality: "Control de calidad y revisión"
  },
  
  enterpriseFeatures: {
    allStandard: "Incluye todas las funciones de la versión estándar",
    manager: "Servicio de gestor exclusivo",
    priority: "Atención prioritaria y servicio express",
    customGlossary: "Glosarios y guías de estilo personalizados",
    discount: "Descuentos por volumen y beneficios por colaboración a largo plazo",
    extraTrial: "Solicitud de créditos de prueba adicionales"
  },
  
  // About Section
  aboutSubtitle: "Acerca de nosotros",
  aboutTitle: "Equipo profesional de localización de videojuegos",
  aboutDescription: "Flidge fue fundada en 2019 como una empresa tecnológica especializada en localización de videojuegos. Combinamos tecnología de IA con revisión profesional humana para ofrecer a los desarrolladores de videojuegos servicios de localización multilingüe de alta calidad y eficiencia, ayudando a que juegos excepcionales alcancen audiencias globales.",
  
  ourMission: "Nuestra misión",
  ourVision: "Nuestra visión",
  missionText: "Derribamos las barreras del idioma mediante tecnología de IA avanzada y servicios profesionales de localización, para que todos los juegos excepcionales puedan triunfar en el mercado global y jugadores de todo el mundo disfruten experiencias extraordinarias.",
  visionText: "Convertirnos en la plataforma líder mundial de servicios de localización de videojuegos, contribuyendo al desarrollo global de la industria mediante innovación tecnológica y servicios profesionales, permitiendo que la excelente cultura de los videojuegos se propague por todo el mundo.",
  
  // FAQ Section
  faqSubtitle: 'Preguntas Frecuentes',
  faqTitle: 'FAQ',
  faqDescription: 'Si tienes más dudas, contáctanos cuando quieras',
  
  faq1Question: "¿Ofrecen una cuota de prueba para traducción?",
  faq1Answer: "Ofrecemos a cada cliente una prueba gratuita de 5000 caracteres para traducción a un solo idioma. Más allá de los 5000 caracteres, el costo es de $0.016 USD por carácter por idioma. Si necesitas más caracteres de prueba gratuitos, puedes contactar a nuestro equipo de ventas para solicitarlos.",
  
  faq2Question: "¿En qué etapa del desarrollo del juego se recomienda comenzar a usar los servicios de Flidge?",
  faq2Answer: "Recomendamos utilizar los servicios de Flidge en las etapas intermedias o finales del desarrollo de tu proyecto de juego, lo que te permitirá optimizar al máximo los costos de localización. Además, podemos brindarte soporte para la traducción de tu página de tienda y ayudarte a seleccionar nombres localizados más adecuados para tu juego, facilitando que los jugadores lo recuerden y apoyándote en la expansión hacia mercados globales.|Si tu juego está próximo a lanzarse en plataformas como Steam, los servicios de Flidge son ideales para ti. Podemos localizar grandes volúmenes de contenido en múltiples idiomas en muy poco tiempo, para que jugadores de todo el mundo puedan descubrir tu juego.",
  
  faq3Question: "¿Qué hago si mi proyecto de juego no tiene un glosario?",
  faq3Answer: "Podemos ofrecerte un servicio de gestión de glosarios a través de Flidge AI para ayudarte a administrar mejor tu proyecto y el contenido a traducir. Trabajaremos contigo para confirmar el uso correcto de la terminología, garantizando que se aplique de manera precisa en tu juego.\nSi necesitas este servicio de gestión de glosarios, no dudes en contactarnos.",
  
  faq4Question: "¿Mi contenido de juego se mantendrá estrictamente confidencial?",
  faq4Answer: "Implementamos encriptación con estándares de la industria y flujos de trabajo compartimentalizados diseñados específicamente para proyectos de videojuegos. Cada miembro del equipo trabaja bajo estrictos acuerdos de confidencialidad con responsabilidad financiera claramente definida. Nuestro entorno de desarrollo garantiza un aislamiento total de activos: sin capturas de pantalla, sin unidades externas, sin dispositivos personales. Entendemos que la filtración de imágenes del juego, elementos narrativos o fechas de lanzamiento puede comprometer el impacto comercial de un título. Tu propiedad intelectual creativa recibirá la misma protección que exigimos para nuestros propios proyectos no publicados.",
  
  // Contact Section
  contactSubtitle: "Contáctanos",
  contactTitle: "Obtén servicios profesionales de traducción y crédito de cortesía",
  contactDescription: "Completa el formulario y nuestro equipo te enviará una propuesta detallada en menos de 24 horas",
  
  name: "Nombre",
  email: "Correo electrónico",
  company: "Nombre de la empresa/estudio",
  targetLanguages: "Idiomas objetivo",
  projectDetails: "Detalles del proyecto",
  getQuote: "Obtener Cotización",
  onlineConsult: "Consulta en línea",
  emailContact: "Contactar por correo",
  
  // Form placeholders
  namePlaceholder: "Por favor ingresa tu nombre",
  emailPlaceholder: "Por favor ingresa tu dirección de correo electrónico",
  companyPlaceholder: "Por favor ingresa el nombre de la empresa o estudio",
  languagesPlaceholder: "ej.: Inglés, Japonés, Coreano, etc.",
  messagePlaceholder: "Por favor describe detalladamente los requisitos de tu proyecto, incluyendo tipo de juego, contenido de traducción, requisitos especiales, etc...",
  
  // Form labels
  required: "*",
  characterCount: "caracteres",
  
  // Common Actions
  contactUs: "Contáctanos",
  viewFaq: "Ver FAQ",
  
  // Footer
  footerDescription: "Ofrecemos servicios de localización eficientes y accesibles para juegos independientes, impulsando su crecimiento global con traducción inteligente, análisis y soluciones lingüísticas personalizadas.",
  services: "Servicios",
  companySection: "Empresa",
  resources: "Principais Vantagens",
  featuresLink: "Ventajas principales",
  pricingConsult: "Precios del servicio",
  aboutUs: "Acerca de nosotros",
  helpCenter: "Centro de ayuda",
  techBlog: "Blog técnico",
  termsOfService: "Términos de Servicio",
  privacyPolicy: "Política de Privacidad",
  cookiePolicy: "Política de Cookies",
  poweredBy: "Powered by Readdy",
  copyright: "© 2026 Shenzhen Giant Core Limited. All rights reserved.",
  
  // Partners
  partners: "Socios",
  trustedPartners: "Aliados de confianza",
  partnersDescription: "Construimos relaciones profundas y duraderas con los mejores equipos de videojuegos y empresas del mundo",
  
  // Statistics and Testimonials Section
  successMetrics: "Métricas de Éxito",
  serviceImpact: "Nuestro impacto",
  clientSatisfactionRate: "Satisfacción del cliente",
  translatedCharactersCount: "5M+",
  translatedCharacters: "Palabras traducidas",
  servicedCompanies: "Empresas atendidas",
  avgTranslationSpeedValue: "24 horas",
  avgTranslationSpeed: "Tiempo de respuesta",
  customerReviews: "Reseñas de clientes",
  realUserFeedback: "Testimonios reales",
  
  // Testimonials
  testimonialSarahRole: "Desarrolladora de Juegos Independiente",
  testimonialSarahContent: "Después de usar Flidge, la respuesta de nuestro juego en mercados internacionales ha sido extraordinaria. La calidad de traducción superó nuestras expectativas; los jugadores comentan que la narrativa se transmite perfectamente, sin ningún rastro de traducción automática.",
  testimonialThijsRole: "Director de Estudio de Juegos",
  testimonialThijsContent: "Desde la traducción inicial del guion hasta la optimización final del texto, el equipo de Flidge demostró un nivel excepcional de profesionalismo. Su comprensión de la cultura de los videojuegos hizo que todo el proceso de localización fluyera sin problemas.",
  testimonialEmmaRole: "Gerente de Localización de Juegos",
  testimonialEmmaContent: "El servicio de traducción de Flidge nos ahorró mucho tiempo y dinero. Su tecnología de IA no solo es rápida, sino que comprende con precisión la terminología especializada y las sutilezas culturales en los juegos.",
  testimonialDavidRole: "Productor de Juegos",
  testimonialDavidContent: "Nuestro juego tuvo un gran éxito en los mercados de Japón y Corea, gracias al excelente servicio de localización de Flidge. Su profundo conocimiento de la cultura asiática logró traducciones realmente auténticas.",
  testimonialAlexRole: "Desarrollador Independiente",
  testimonialAlexContent: "Como equipo pequeño, lo que más nos preocupaba era el costo de localización. Flidge no solo ofrece precios accesibles, además su eficiencia excepcional nos permitió entrar simultáneamente a varios mercados internacionales.",
  testimonialYukiRole: "Planificador de Juegos",
  testimonialYukiContent: "Me impresionó muchísimo cómo Flidge entiende la cultura de los juegos japoneses. No solo tradujeron las palabras, sino que transmitieron la esencia del juego, logrando que los jugadores internacionales vivan una experiencia completamente auténtica.",
  
  stillHaveQuestions: "¿Tiene dudas?",
  
  // New Pricing Calculator Section
  priceCalculator: "Calculadora de Precios",
  calculatorDescription: "Estime rápidamente el costo de traducción de su proyecto",
  charactersCount: "Número de caracteres",
  targetLanguagesCount: "Idiomas destino",
  estimatedCost: "Costo aproximado",
  
  calculationNotes: "Detalhes do cálculo",
  calculationDetails: {
    freeQuota: "Cada colaborador dispone de 5000 caracteres gratuitos (limitados a un idioma)",
    pricing: "Se cobra $0.011/carácter/idioma por el excedente",
    bulkDiscount: "Proyectos de gran volumen pueden acceder a precios corporativos personalizados",
    finalPrice: "El precio final depende de la cotización del equipo comercial"
  },

  // Terms of Service
  termsTitle: 'Términos de Servicio',
  termsLastUpdated: 'Última actualización: Enero 2025',
  terms1Title: '1. Aceptación de Términos',
  terms1Content: 'Al acceder y usar los Servicios de Traducción AI de Flidge, acepta y acuerda estar sujeto a los términos y disposiciones de este acuerdo.',
  terms2Title: '2. Licencia de Uso',
  terms2Content: 'Se otorga permiso para descargar temporalmente una copia de los materiales en el sitio web de Flidge solo para visualización personal y no comercial.',
  terms3Title: '3. Descargo de Responsabilidad',
  terms3Content: 'Los materiales en el sitio web de Flidge se proporcionan "tal como están". Flidge no ofrece garantías expresas o implícitas.',
  terms4Title: '4. Limitaciones',
  terms4Content: 'En ningún caso Flidge o sus proveedores serán responsables de cualquier daño que surja del uso o la incapacidad de usar los materiales.',
  terms5Title: '5. Precisión de los Materiales',
  terms5Content: 'Los materiales que aparecen en el sitio web de Flidge podrían incluir errores técnicos, tipográficos o fotográficos.',
  terms6Title: '6. Enlaces',
  terms6Content: 'Flidge no ha revisado todos los sitios vinculados a nuestro sitio web y no es responsable del contenido de dichos sitios.',
  terms7Title: '7. Modificaciones',
  terms7Content: 'Flidge puede revisar estos términos de servicio en cualquier momento sin previo aviso.',
  terms8Title: '8. Ley Aplicable',
  terms8Content: 'Estos términos y condiciones se rigen e interpretan de acuerdo con las leyes aplicables.',

  // Privacy Policy
  privacyTitle: 'Política de Privacidad',
  privacyLastUpdated: 'Última actualización: Enero 2025',
  privacy1Title: '1. Información que Recopilamos',
  privacy1Content: 'Recopilamos información que nos proporciona directamente, como cuando crea una cuenta o utiliza nuestros servicios de traducción.',
  privacy2Title: '2. Cómo Usamos Su Información',
  privacy2Content: 'Utilizamos la información recopilada para proporcionar, mantener y mejorar nuestros servicios de traducción.',
  privacy3Title: '3. Compartir Información',
  privacy3Content: 'No vendemos, intercambiamos o transferimos su información personal a terceros sin su consentimiento.',
  privacy4Title: '4. Seguridad de Datos',
  privacy4Content: 'Implementamos medidas de seguridad apropiadas para proteger su información personal.',
  privacy5Title: '5. Retención de Datos',
  privacy5Content: 'Conservamos su información personal durante el tiempo necesario para proporcionar nuestros servicios.',
  privacy6Title: '6. Sus Derechos',
  privacy6Content: 'Tiene derecho a acceder, actualizar y solicitar la eliminación de su información personal.',
  privacy7Title: '7. Cookies y Seguimiento',
  privacy7Content: 'Utilizamos cookies y tecnologías de seguimiento similares para mejorar su experiencia en nuestro sitio web.',
  privacy8Title: '8. Transferencias Internacionales',
  privacy8Content: 'Su información puede ser transferida y procesada en países distintos al suyo.',
  privacy9Title: '9. Cambios a Esta Política',
  privacy9Content: 'Podemos actualizar esta Política de Privacidad de vez en cuando.',
  privacy10Title: '10. Contáctenos',
  privacy10Content: 'Si tiene preguntas sobre esta Política de Privacidad, contáctenos en privacy@flidge.ai.',

  // Cookie Policy
  cookieTitle: 'Política de Cookies',
  cookieLastUpdated: 'Última actualización: Enero 2025',
  cookie1Title: '1. Qué son las Cookies',
  cookie1Content: 'Las cookies son pequeños archivos de texto que se colocan en su dispositivo cuando visita nuestro sitio web.',
  cookie2Title: '2. Tipos de Cookies que Usamos',
  cookie2Content: 'Utilizamos cookies esenciales para funciones básicas del sitio web, cookies de rendimiento para analizar patrones de uso y cookies funcionales.',
  cookie2Essential: 'Cookies Esenciales',
  cookie2EssentialDesc: 'Estas cookies son necesarias para que el sitio web funcione correctamente.',
  cookie2Performance: 'Cookies de Rendimiento',
  cookie2PerformanceDesc: 'Estas cookies recopilan información sobre cómo los visitantes usan nuestro sitio web.',
  cookie2Functional: 'Cookies Funcionales',
  cookie2FunctionalDesc: 'Estas cookies permiten que el sitio web recuerde las decisiones que toma.',
  cookie3Title: '3. Cookies de Terceros',
  cookie3Content: 'Podemos usar servicios de terceros que colocan cookies en su dispositivo.',
  cookie4Title: '4. Gestionar Cookies',
  cookie4Content: 'Puede controlar y gestionar las cookies a través de la configuración de su navegador.',
  cookie5Title: '5. Consentimiento de Cookies',
  cookie5Content: 'Al continuar usando nuestro sitio web, consiente nuestro uso de cookies según se describe en esta política.',
  cookie6Title: '6. Impacto de Deshabilitar Cookies',
  cookie6Content: 'Si elige deshabilitar las cookies, algunas características de nuestro sitio web pueden no funcionar correctamente.',
  cookie7Title: '7. Actualizaciones a Esta Política',
  cookie7Content: 'Podemos actualizar esta Política de Cookies de vez en cuando.',
  cookie8Title: '8. Información de Contacto',
  cookie8Content: 'Si tiene preguntas sobre nuestro uso de cookies, contáctenos en cookies@flidge.ai.'
};

export default common;
